<!-- submenu.component.html -->
<div class="p-4 border-b border-b-[#DBDFE9] text-center">
  <h2 class="font-medium text-sm text-[#252F4A]">{{selectedTitle}}</h2>
</div>

<!-- For Profile Popup -->
<div class="py-2.5 px-5" *ngIf="selectedType === 'profile'">
  <app-profile [inlineMode]="true"></app-profile>
</div>


<!-- For Tickets Navigation -->
<div class="py-2.5 px-5" *ngIf="selectedType === 'ticket'">
  <ul class="font-medium text-sm text-[#252F4A]">
    <li>
      <a [routerLink]="['/tickets/table']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/table.svg" alt="table">
        <span>Table</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets/kanban']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/kanban.svg" alt="kanban">
        <span>Kanban</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets/calender']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/calender.svg" alt="calender">
        <span>Calendar</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets/resources']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/resources.svg" alt="resources">
        <span>Resources</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets/location']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/location.svg" alt="location">
        <span>Location</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets/dashboard']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/dashboard.svg" alt="dashboard">
        <span>Dashboard</span>
      </a>
    </li>
    <li class="py-3">
      <bk-button 
        variant="primary"
        label="Create a new ticket"
        size="sm"
        [loading]="false" 
        [disabled]="false" 
        buttonClass="text-[#6B7080] border-[#E3E6EE] bg-white w-full !py-[5px] rounded-md">
      </bk-button>
    </li>
  </ul>
</div>


<!-- For Setup Navigation -->
<div class="py-2.5 px-5" *ngIf="selectedType === 'setup'">
  <ul class="font-medium text-sm text-[#252F4A]">
    <li>
      <a [routerLink]="['/tickets-setup/facility']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/table.svg" alt="table">
        <span>Facilities</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets-setup/job']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/job.svg" alt="job">
        <span>Job</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets-setup/resolution']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/resolution.svg" alt="resolution">
        <span>Resolution</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets-setup/status']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/status.svg" alt="resources">
        <span>Status</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/tickets-setup/priority']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/priority.svg" alt="priority">
        <span>Priority</span>
      </a>
    </li>
  </ul>
</div>


<!-- For Business Setup Navigation -->
<div class="py-2.5 px-5" *ngIf="selectedType === 'employee'">
  <ul class="font-medium text-sm text-[#252F4A]">
    <li>
      <a [routerLink]="['/employees']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/table.svg" alt="table">
        <span>Employees</span>
      </a>
    </li>
    <li>
      <a [routerLink]="['/employees']" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/roles.svg" alt="roles">
        <span>Roles</span>
      </a>
    </li>
  </ul>
</div>



<div class="py-2.5 px-5" *ngIf="selectedType === 'finance'">

  <ul class="font-medium text-sm text-[#252F4A]">
    <li>
      <a href="javascript:void(0)" class="flex items-center gap-2.5 py-3">
        <img src="./assets/images/icons/navigation/product.svg" alt="product">
        <span>Products</span>
      </a>
    </li>
  </ul>

  <!-- Finance Accounts Accordion -->
  <cdk-accordion class="w-full">
    <cdk-accordion-item>
      <div
        class="font-medium text-sm text-[#252F4A] flex items-center justify-between gap-2.5 py-3 cursor-pointer"
        role="button"
        (click)="toggle('accounts', 0)"
        [attr.aria-expanded]="accordionStates['accounts'] === 0">

        <div class="flex items-center gap-2.5">
          <img src="./assets/images/icons/navigation/account.svg" alt="account">
          <span>Accounts</span>
        </div>

        @if (accordionStates['accounts'] === 0) {
          <img src="./assets/images/icons/global/minus.svg" alt="minus">
        } @else {
          <img src="./assets/images/icons/global/plus.svg" alt="plus">
        }
      </div>

      <div
        [@expandCollapse]="accordionStates['accounts'] === 0 ? 'expanded' : 'collapsed'"
        class="overflow-hidden">
        <ul class="font-medium text-sm text-[#6D7794] relative pl-7
                   before:content-[''] before:absolute before:top-0 before:left-2 before:w-px before:h-full before:bg-[#DBDFE9]">
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Chart of Accounts</span></a></li>
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Customers</span></a></li>
        </ul>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>

  <!-- Finance Orders Accordion -->
  <cdk-accordion class="w-full">
    <cdk-accordion-item>
      <div
        class="font-medium text-sm text-[#252F4A] flex items-center justify-between gap-2.5 py-3 cursor-pointer"
        role="button"
        (click)="toggle('orders', 0)"
        [attr.aria-expanded]="accordionStates['orders'] === 0">

        <div class="flex items-center gap-2.5">
          <img src="./assets/images/icons/navigation/order.svg" alt="order">
          <span>Orders</span>
        </div>

        @if (accordionStates['orders'] === 0) {
          <img src="./assets/images/icons/global/minus.svg" alt="minus">
        } @else {
          <img src="./assets/images/icons/global/plus.svg" alt="plus">
        }
      </div>

      <div
        [@expandCollapse]="accordionStates['orders'] === 0 ? 'expanded' : 'collapsed'"
        class="overflow-hidden">
        <ul class="font-medium text-sm text-[#6D7794] relative pl-7
                   before:content-[''] before:absolute before:top-0 before:left-2 before:w-px before:h-full before:bg-[#DBDFE9]">
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Purchase Order</span></a></li>
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Purchase Invoice</span></a></li>
        </ul>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>

  <!-- Finance Vouchers Accordion -->
  <cdk-accordion class="w-full">
    <cdk-accordion-item>
      <div
        class="font-medium text-sm text-[#252F4A] flex items-center justify-between gap-2.5 py-3 cursor-pointer"
        role="button"
        (click)="toggle('vouchers', 0)"
        [attr.aria-expanded]="accordionStates['orders'] === 0">

        <div class="flex items-center gap-2.5">
          <img src="./assets/images/icons/navigation/voucher.svg" alt="order">
          <span>Vouchers</span>
        </div>

        @if (accordionStates['vouchers'] === 0) {
          <img src="./assets/images/icons/global/minus.svg" alt="minus">
        } @else {
          <img src="./assets/images/icons/global/plus.svg" alt="plus">
        }
      </div>

      <div
        [@expandCollapse]="accordionStates['vouchers'] === 0 ? 'expanded' : 'collapsed'"
        class="overflow-hidden">
        <ul class="font-medium text-sm text-[#6D7794] relative pl-7
                   before:content-[''] before:absolute before:top-0 before:left-2 before:w-px before:h-full before:bg-[#DBDFE9]">
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Journal Voucher</span></a></li>
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Cash Voucher</span></a></li>
        </ul>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>

  <!-- Finance Reports Accordion -->
  <cdk-accordion class="w-full">
    <cdk-accordion-item>
      <div
        class="font-medium text-sm text-[#252F4A] flex items-center justify-between gap-2.5 py-3 cursor-pointer"
        role="button"
        (click)="toggle('reports', 0)"
        [attr.aria-expanded]="accordionStates['orders'] === 0">

        <div class="flex items-center gap-2.5">
          <img src="./assets/images/icons/navigation/report.svg" alt="report">
          <span>Reports</span>
        </div>

        @if (accordionStates['reports'] === 0) {
          <img src="./assets/images/icons/global/minus.svg" alt="minus">
        } @else {
          <img src="./assets/images/icons/global/plus.svg" alt="plus">
        }
      </div>

      <div
        [@expandCollapse]="accordionStates['reports'] === 0 ? 'expanded' : 'collapsed'"
        class="overflow-hidden">
        <ul class="font-medium text-sm text-[#6D7794] relative pl-7
                   before:content-[''] before:absolute before:top-0 before:left-2 before:w-px before:h-full before:bg-[#DBDFE9]">
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Ledger</span></a></li>
          <li><a href="javascript:void(0)" class="flex items-center gap-2.5 py-2"><span>Cashbook</span></a></li>
        </ul>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>

</div>

